(function () {
  var utils = window.CiSearchUtils || {};
  var INDEX_SECTION = 'ci-product-search-index';
  var INDEX_PATH = '/collections/all';
  var indexCache = null;
  var indexPromise = null;

  function parseIndexItem(el) {
    return {
      handle: (el.getAttribute('data-product-handle') || '').trim().toLowerCase(),
      html: el.outerHTML,
      meta: utils.getProductMetaFromElement
        ? utils.getProductMetaFromElement(el)
        : {
            title: el.getAttribute('data-product-title') || '',
            vendor: el.getAttribute('data-product-vendor') || '',
            handle: el.getAttribute('data-product-handle') || '',
            searchText: el.getAttribute('data-ci-search-text') || '',
          },
    };
  }

  function fetchIndexPage(page) {
    var url = new URL(INDEX_PATH, window.location.origin);
    url.searchParams.set('section_id', INDEX_SECTION);
    if (page && page > 1) url.searchParams.set('page', String(page));

    return fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Index request failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-ci-search-index-root]');
        if (!root) return { items: [], pages: 1 };

        var pages = parseInt(root.getAttribute('data-pages') || '1', 10) || 1;
        var items = Array.from(root.querySelectorAll('[data-ci-search-index-item]')).map(parseIndexItem);
        return { items: items, pages: pages };
      });
  }

  function fetchAllIndexItems() {
    return fetchIndexPage(1).then(function (first) {
      if (first.pages <= 1) return first.items;

      var pageFetches = [];
      for (var page = 2; page <= first.pages; page += 1) {
        pageFetches.push(fetchIndexPage(page));
      }

      return Promise.all(pageFetches).then(function (rest) {
        var items = first.items.slice();
        rest.forEach(function (payload) {
          items = items.concat(payload.items);
        });
        return items;
      });
    });
  }

  function loadIndex(forceReload) {
    if (forceReload) {
      indexCache = null;
      indexPromise = null;
    }
    if (indexCache) return Promise.resolve(indexCache);
    if (indexPromise) return indexPromise;

    indexPromise = fetchAllIndexItems()
      .then(function (items) {
        indexCache = items;
        return items;
      })
      .catch(function () {
        indexPromise = null;
        return [];
      });

    return indexPromise;
  }

  function filterItems(items, query, options) {
    options = options || {};
    if (!utils.isSearchableQuery || !utils.isSearchableQuery(query)) return [];

    var handleSet = options.handleSet || null;

    return items.filter(function (item) {
      if (handleSet && handleSet.size && !handleSet.has(item.handle)) return false;
      return utils.productMatchesQuery(item.meta, query);
    });
  }

  function updateSearchCounts(count, query) {
    var countText = String(count);

    document.querySelectorAll('[data-ci-search-state]').forEach(function (state) {
      state.setAttribute('data-results-count', countText);
      if (query) state.setAttribute('data-query', query);
    });

    document.querySelectorAll('[data-ci-search-hero-count]').forEach(function (el) {
      el.textContent = countText;
    });

    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      if (query) {
        el.textContent = count + ' resultados para "' + query + '"';
      } else {
        el.textContent = count + ' productos';
      }
    });
  }

  function dispatchGridUpdated(root) {
    document.dispatchEvent(
      new CustomEvent('ci:product-grid:updated', {
        detail: { root: root || document },
      })
    );
  }

  function adaptItemHtmlForSearchPage(html) {
    if (!html || html.indexOf('grid__item') !== -1) return html;
    return html.replace('class="ci-cbg__item', 'class="grid__item ci-cbg__item');
  }

  function adaptItemHtmlForCollectionGrid(html) {
    if (!html) return html;
    return html
      .replace(/\sgrid__item/g, '')
      .replace(/\sgrid__item\s/g, ' ')
      .replace('class=" ', 'class="');
  }

  function buildSearchGridHtml(matches, options) {
    options = options || {};
    var publishedHandles = options.publishedHandles || '';
    var query = options.query || '';
    var initial = options.initialCount || 28;
    var step = options.stepCount || 12;
    var sectionId = options.sectionId || 'main-search';
    var itemsHtml = matches
      .map(function (item) {
        return adaptItemHtmlForSearchPage(item.html);
      })
      .join('');

    if (!itemsHtml) {
      return (
        '<div class="template-search__results collection collection--empty page-width" id="product-grid">' +
        '<div class="title-wrapper center"><h2 class="title title--primary">' +
        'No se encontraron resultados para &ldquo;' +
        query.replace(/</g, '&lt;') +
        '&rdquo;. Revisa la ortografía o usa otra palabra.</h2></div></div>'
      );
    }

    return (
      '<div data-ci-load-more-root data-ci-storefront-filter="true"' +
      (publishedHandles ? ' data-ci-published-brand-handles="' + publishedHandles + '"' : '') +
      ' data-ci-load-more-initial="' +
      initial +
      '" data-ci-load-more-step="' +
      step +
      '" data-ci-load-more-page="1" data-ci-load-more-pages="1" data-ci-load-more-section-id="' +
      sectionId +
      '" data-ci-load-more-fetch-path="/search" data-ci-load-more-search-query="' +
      query.replace(/"/g, '&quot;') +
      '" data-ci-search-results-count="' +
      matches.length +
      '" class="template-search__results collection page-width" id="product-grid">' +
      '<ul class="ci-pgrid product-grid" role="list">' +
      itemsHtml +
      '</ul></div>'
    );
  }

  function buildCollectionGridHtml(matches, options) {
    options = options || {};
    var query = options.query || '';
    var noResultsText = options.noResultsText || 'No se encontraron productos con ese nombre.';
    var publishedHandles = options.publishedHandles || '';
    var initial = options.initialCount || 28;
    var step = options.stepCount || 12;

    if (!matches.length) {
      return (
        '<div class="ci-cbg__grid-shell" data-ci-search-results-count="0">' +
        '<p class="ci-cbg__no-results" data-brand-no-results>' +
        noResultsText.replace(/</g, '&lt;') +
        '</p></div>'
      );
    }

    var itemsHtml = matches
      .map(function (item) {
        return adaptItemHtmlForCollectionGrid(item.html);
      })
      .join('');

    return (
      '<div class="ci-cbg__grid-shell" data-ci-load-more-root data-ci-storefront-filter="true"' +
      (publishedHandles ? ' data-ci-published-brand-handles="' + publishedHandles + '"' : '') +
      ' data-ci-scoped-collection-search="true" data-ci-load-more-initial="' +
      initial +
      '" data-ci-load-more-step="' +
      step +
      '" data-ci-load-more-page="1" data-ci-load-more-pages="1" data-ci-load-more-section-id="ci-collection-search" data-ci-load-more-fetch-path="/search" data-ci-load-more-search-query="' +
      query.replace(/"/g, '&quot;') +
      '" data-ci-search-results-count="' +
      matches.length +
      '" data-ci-search-query="' +
      query.replace(/"/g, '&quot;') +
      '">' +
      '<ul class="ci-cbg__grid" role="list" data-brand-grid-list>' +
      itemsHtml +
      '</ul>' +
      '<p class="ci-cbg__no-results" data-brand-no-results hidden>' +
      noResultsText.replace(/</g, '&lt;') +
      '</p></div>'
    );
  }

  function search(query, options) {
    options = options || {};
    return loadIndex(options.forceReload).then(function (items) {
      return filterItems(items, query, options);
    });
  }

  function renderSearchPage(query, options) {
    options = options || {};
    var gridContainer = options.gridContainer || document.getElementById('ProductGridContainer');
    if (!gridContainer) return Promise.resolve(0);

    return search(query, options).then(function (matches) {
      gridContainer.innerHTML = buildSearchGridHtml(matches, {
        query: query,
        publishedHandles: options.publishedHandles,
        initialCount: options.initialCount,
        stepCount: options.stepCount,
        sectionId: options.sectionId,
      });

      var templateSearch = document.querySelector('.template-search');
      if (templateSearch) {
        templateSearch.classList.toggle('template-search--empty', matches.length === 0);
      }

      updateSearchCounts(matches.length, query);
      dispatchGridUpdated(gridContainer);

      if (window.CiStorefrontProductFilter && typeof window.CiStorefrontProductFilter.init === 'function') {
        window.CiStorefrontProductFilter.init(gridContainer);
      }

      return matches.length;
    });
  }

  function renderCollectionGrid(query, options) {
    options = options || {};
    var gridContainer = options.gridContainer;
    if (!gridContainer) return Promise.resolve(0);

    return search(query, options).then(function (matches) {
      gridContainer.innerHTML = buildCollectionGridHtml(matches, {
        query: query,
        noResultsText: options.noResultsText,
        publishedHandles: options.publishedHandles,
        initialCount: options.initialCount,
        stepCount: options.stepCount,
      });

      dispatchGridUpdated(gridContainer);
      if (options.section) {
        options.section.classList.toggle('is-search-empty', matches.length === 0);
      }

      if (window.CiStorefrontProductFilter && typeof window.CiStorefrontProductFilter.init === 'function') {
        window.CiStorefrontProductFilter.init(gridContainer);
      }

      return matches.length;
    });
  }

  window.CiClientSearch = {
    loadIndex: loadIndex,
    search: search,
    filterItems: filterItems,
    renderSearchPage: renderSearchPage,
    renderCollectionGrid: renderCollectionGrid,
    updateSearchCounts: updateSearchCounts,
  };
})();
